import gql from 'graphql-tag'

export const CREATE_RETURN = gql`
  mutation createReturn($input: CreateReturnInput!) {
    createReturn(input: $input) {
      returnOrder {
        id
      }
      errors
    }
  }
`

export default {
  CREATE_RETURN
}
